// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","list":"Footer_list__1QJ4w"};